/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type ModulesConfigAuditListModule = typeof ModulesConfigAuditListModule[keyof typeof ModulesConfigAuditListModule];


export const ModulesConfigAuditListModule = {
  business_finance: 'business_finance',
  iot_gec: 'iot_gec',
  life_line: 'life_line',
  personal_finance: 'personal_finance',
  ranking: 'ranking',
} as const;
